"use strict";
// tslint:disable:object-literal-sort-keys
/**
 * @file html-binding-controls.js
 * @copyright 2016 Microsoft Corporation
 */
var $dyn;
(function ($dyn) {
    /**
     * Localization strings
     * @readonly
     */
    Globalize.addCultureInfo("en", {
        messages: {
            Framework_UnknownControl: "Unknown control: {0}, name: {1}",
            Framework_InvalidKeyCombo: "The key combination ({0}) is not a command.",
            Framework_ChordStarted: "({0}) was pressed.  Waiting for second part of key sequence...",
        },
    });
    var controls;
    (function (controls) {
        /** @private Placeholder variable that ensures that the $dyn.controls namespace is initialized. */
        controls.__namespace_created = true;
    })(controls = $dyn.controls || ($dyn.controls = {}));
    var ui;
    (function (ui) {
        /**
         * Forms need to explicitly call makeRoot so they are registered as $root in the data context
         */
        function makeRoot(control) {
            if (!control || !control.element) {
                return;
            }
            var role = $dyn.role(control.element);
            var context = role.context;
            if (!context) {
                return;
            }
            context.scopeVars.$root = control;
        }
        ui.makeRoot = makeRoot;
        var RootType;
        (function (RootType) {
            RootType["form"] = "Form";
            RootType["appBar"] = "AppBarSection";
            RootType["dialog"] = "Dialog";
            RootType["dropDialog"] = "DropDialog";
            RootType["lookupPicker"] = "LookupPicker";
            RootType["columnHeader"] = "ColumnHeader";
        })(RootType = ui.RootType || (ui.RootType = {}));
        /**
         * Find the element of the top most root of the specified root type
         * @returns The root element
         */
        function findRootElement(rootOrRootType) {
            /// Finds the top level elements
            var rootElement;
            $dyn.debug.findControl && $dyn.logGroup("Call to findRootElement: root type: %o", rootOrRootType);
            if (!rootOrRootType) {
                $dyn.debug.findControl && $dyn.log("Result findRootElement: not found");
                $dyn.debug.findControl && $dyn.logGroupEnd();
                return;
            }
            if (rootOrRootType.nodeType) {
                $dyn.debug.findControl && $dyn.log("Result findRootElement: html control");
                $dyn.debug.findControl && $dyn.logGroupEnd();
                // It's an html element
                return rootOrRootType;
            }
            else if (rootOrRootType instanceof jQuery) {
                return rootOrRootType[0];
            }
            switch (rootOrRootType) {
                case $dyn.ui.RootType.form:
                    var form = $dyn.shell.getCurrentRootForm();
                    if (form && form.dynReadyState() === "ready") {
                        rootElement = form;
                    }
                    break;
                case $dyn.ui.RootType.appBar:
                    rootElement = $(".active-form .appBar")[0];
                    break;
                case $dyn.ui.RootType.dialog:
                    var dialog = $dyn.shell.getCurrentDialog();
                    if (dialog && dialog.dynReadyState() === "ready") {
                        rootElement = dialog;
                    }
                    break;
                case $dyn.ui.RootType.lookupPicker:
                    rootElement = $("[data-dyn-role=Popup]")[0];
                    break;
                case $dyn.ui.RootType.dropDialog:
                    rootElement = $("[data-dyn-role=DropDialogPopup]")[0];
                    break;
                case $dyn.ui.RootType.columnHeader:
                    rootElement = $("[data-dyn-role=ColumnHeaderPopup][data-dyn-lastvisible=true]")[0];
                    break;
            }
            $dyn.debug.findControl && $dyn.log("Result findRootElement: %o", rootElement);
            $dyn.debug.findControl && $dyn.logGroupEnd();
            return rootElement;
        }
        ui.findRootElement = findRootElement;
        /**
         * Find the context of the top most root of the specified root type
         * @returns The root context
         */
        function findRootControl(rootOrRootType) {
            var foundElement = $dyn.ui.findRootElement(rootOrRootType);
            return $dyn.context(foundElement);
        }
        ui.findRootControl = findRootControl;
        /**
         * Find the control with the specified control name wihtin the specified root type
         * @returns The found control
         */
        function findControl(controlName, rootOrRootType) {
            $dyn.debug.findControl && $dyn.logGroup("Call to findControl: control: %o, root: %o", controlName, rootOrRootType);
            var foundElement = $dyn.ui.findControlElement(controlName, rootOrRootType);
            $dyn.debug.findControl && $dyn.log("Return value findControl: %o", foundElement);
            $dyn.debug.findControl && $dyn.logGroupEnd();
            var context = $dyn.context(foundElement);
            if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName) && foundElement) {
                if (!context || (context.TypeName === "ReactList" && foundElement !== context.element)) {
                    context = $dyn.ui.getLiveControl(foundElement);
                }
            }
            return context;
        }
        ui.findControl = findControl;
        /**
         * Find the element with the specified control name wihtin the specified root type
         * @returns The found control element
         */
        function findControlElement(controlName, rootOrRootType) {
            // Note: Don't expose findMatchingElements as a public API as it has no core utility beyond $dyn.ui.findControlElement and
            // makes it unclear as to which API should be used. This was original exposed as $dyn.ui.findElements even though its core
            // intent was to find only a single element.
            // tslint:disable-next-line:no-shadowed-variable
            var findMatchingElements = function (controlName, rootOrRootType) {
                var elements;
                var root = $($dyn.ui.findRootElement(rootOrRootType));
                if (!root.length) {
                    $dyn.logWarning("Couldn't find root element identified by " + rootOrRootType);
                    // exit early, root element not found.
                    return null;
                }
                if (!controlName) {
                    elements = root;
                }
                else {
                    var foundInList = root.find(".listView [data-dyn-controlname='" + controlName + "']");
                    if (!foundInList || !foundInList.length) {
                        foundInList = root.find(".listHeader [data-dyn-columnname='" + controlName + "']");
                    }
                    if (foundInList && foundInList.length) {
                        var listContext = $dyn.context(foundInList.closest(".listRoot")[0]);
                        if (listContext) {
                            // First checks if there is any server selected row for Grid.
                            if (listContext.findFieldByNameInServerSelectedRow) {
                                elements = listContext.findFieldByNameInServerSelectedRow(controlName);
                            }
                            if (!elements || !elements.length) {
                                elements = listContext.findFieldByName(controlName);
                            }
                            if (!elements || !elements.length) {
                                elements = foundInList;
                            }
                        }
                    }
                    else {
                        var foundInReactList = root.find(".reactGrid [data-dyn-controlname='" + controlName + "']");
                        if (foundInReactList && foundInReactList.length) {
                            var foundInActiveRow = root.find(".reactGrid .dyn-activeRowCell [data-dyn-controlname='" + controlName + "']");
                            if (foundInActiveRow && foundInActiveRow.length) {
                                elements = foundInActiveRow;
                            }
                            else {
                                var foundInHeader = root.find(".reactGrid .dyn-headerCell[data-dyn-controlname='" + controlName + "']");
                                if (foundInHeader && foundInHeader.length) {
                                    elements = foundInHeader;
                                }
                            }
                        }
                    }
                    // If it is a clientside only control, eliminate the active row constraint and use jquery search.
                    if (!elements || !elements.length) {
                        var candidates = root.find("[data-dyn-controlname='" + controlName + "']");
                        elements = [];
                        candidates.each(function (index, element) {
                            if (!element.isHiddenFromFind) {
                                elements.push(element);
                            }
                        });
                    }
                }
                return elements;
            };
            var foundElements = findMatchingElements(controlName, rootOrRootType);
            if (foundElements && foundElements.length === 1) {
                return foundElements[0];
            }
            // Make sure that we found the element that is the control.
            if (foundElements) {
                for (var i = 0, len = foundElements.length; i < len; i++) {
                    var foundElement = foundElements[i];
                    if (foundElement) {
                        var control = $dyn.context(foundElement);
                        if (control) {
                            return foundElement;
                        }
                    }
                }
            }
        }
        ui.findControlElement = findControlElement;
        /**
         * Find a control element by name in the currently active flyouts that logically belong to a given form
         * @internal
         */
        function findFlyoutControlElement(controlName, formId) {
            if (controlName) {
                var controlElement = void 0;
                var flyoutElements = $dyn.flyout.flyoutManager.getAllFlyoutElementsByParentFormId(formId);
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < flyoutElements.length; i++) {
                    var flyoutElement = flyoutElements[i];
                    controlElement = $dyn.ui.findControlElement(controlName, flyoutElement);
                    if (controlElement) {
                        return controlElement;
                    }
                }
            }
        }
        ui.findFlyoutControlElement = findFlyoutControlElement;
        /**
         * Find the virtualized context wrapper
         * @description Internal method of the control system to find the context of an element even if the element has been virtualized.
         * When virtualized, the element will not have a dynContext (or any other custom properties than have been added to the source element).
         * This method can be used if callbacks to get the virtual context after the element has been rendered and cloned (i.e. virtualized)
         * If the element has been virtualized in a list then the context will be based off of active row (i.e. the control passed a child to the virtualizing control).
         * Because of this consumers should use serialized dom state rather that relying on state that varies per instance.
         * @internal
         */
        function _findVirtualizedContextWrapper(element) {
            if (element.dynContext) {
                return element.dynContext;
            }
            var controlElement = $(element)
                .closest("[data-dyn-controlname]")
                .addBack()[0];
            var virtualContextElement = $(controlElement).closest("[data-dyn-virtualcontext]")[0];
            if (virtualContextElement && virtualContextElement.dynVirtualContext) {
                var contextWrapper = virtualContextElement.dynVirtualContext.getContext(element);
                if (contextWrapper) {
                    return contextWrapper;
                }
            }
            return new $dyn.DataContext();
        }
        ui._findVirtualizedContextWrapper = _findVirtualizedContextWrapper;
        /**
         * Gets the context on the element
         * @internal
         */
        function getLiveControl(element) {
            if (!element) {
                return undefined;
            }
            var context = null;
            var contextWrapper = $dyn.ui._findVirtualizedContextWrapper(element);
            if (contextWrapper && contextWrapper.current) {
                context = contextWrapper.current;
            }
            else {
                // the element doesn't have a context or virtualized context, find the closest control's context
                var activeElement = $(element)
                    .closest("[data-dyn-controlname]")
                    .addBack()[0];
                if (activeElement) {
                    context = $dyn.context(activeElement);
                    if (!context) {
                        var reactGridElement = $(activeElement).closest(".react-listRoot")[0];
                        if (reactGridElement) {
                            context = $dyn.context(reactGridElement);
                        }
                    }
                }
            }
            if (context && context.getLiveControl) {
                context = context.getLiveControl(element);
            }
            return context;
        }
        ui.getLiveControl = getLiveControl;
        /**
         * Determines if helptext should be shown based on having a label and showlabel set to try
         * @internal
         * @param control The current control
         * @returns Should helptext be shown
         */
        function shouldFieldShowHelp(control) {
            if ($dyn.value(control.ShowLabel) && $dyn.value(control.Label)) {
                var helpText = $dyn.value(control.HelpText);
                if (helpText) {
                    return true;
                }
            }
            return false;
        }
        ui.shouldFieldShowHelp = shouldFieldShowHelp;
    })(ui = $dyn.ui || ($dyn.ui = {}));
    /**
     * Gets the data source form the context on the element
     * @internal
     */
    function dataSource(element) {
        var context = $dyn.context(element);
        if (context) {
            return context.DataSource;
        }
    }
    $dyn.dataSource = dataSource;
    /**
     * Creates a control in the $dyn.controls namespace if that id doesn't already exist
     * @internal
     */
    function adapter(settings) {
        if (!settings.controlType) {
            settings.controlType = settings.id;
        }
        var controlsNamespace = $dyn.controls;
        if (!controlsNamespace[settings.id]) {
            var base_1 = controlsNamespace[settings.controlType];
            controlsNamespace[settings.id] = function () {
                base_1.apply(this, arguments);
            };
            controlsNamespace[settings.id].prototype = Object.create(controlsNamespace[settings.controlType].prototype);
        }
        controlsNamespace[settings.id].prototype.template = settings.template;
        return controlsNamespace[settings.id];
    }
    $dyn.adapter = adapter;
    /**
     * Calls into $dyn.adapter with an updated id that reflects the cell
     * @internal
     */
    function cellAdapter(settings) {
        var cellType = settings.type === cellTypes.editor ? "cellEditor" : "cellRoleName";
        if (!settings.cellRoleName) {
            settings.cellRoleName = settings.id + (settings.type === cellTypes.editor ? "CellEditor" : "Cell");
        }
        if (!settings.controlType) {
            settings.controlType = settings.id;
        }
        if (!settings.template) {
            settings.template = settings.cellRoleName;
        }
        var controlsNamespace = $dyn.controls;
        controlsNamespace[settings.id].prototype[cellType] = settings.cellRoleName;
        settings.id = settings.cellRoleName;
        return $dyn.adapter(settings);
    }
    $dyn.cellAdapter = cellAdapter;
    /**
     * @internal
     */
    var cellTypes;
    (function (cellTypes) {
        cellTypes[cellTypes["readOnly"] = 1] = "readOnly";
        cellTypes[cellTypes["editor"] = 2] = "editor";
    })(cellTypes = $dyn.cellTypes || ($dyn.cellTypes = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=html-binding-controls.js.map
